import * as React from "react";

import type { SetTooltipProps } from "@1js/acui-common";
import type { ExperimentChecker } from "@1js/acui-experiments";

export interface ContextLogger {
  onMessage: (message: string) => void;
  onWarning: (message: string) => void;
  onError: (message: string) => void;
}

export interface AppContextType extends ExperimentChecker {
  setTooltipElement?: (tooltipProps: SetTooltipProps) => void;
  updateTooltipsHidden?: (hideAllTooltips: boolean) => void;
  appWindow?: Window;
  responsiveClassName?: string;
  logger?: ContextLogger;
}

export const AppContext: React.Context<AppContextType> = React.createContext(
  {}
);
AppContext.displayName = "AppContext";
